import { Button, ButtonGroup } from "@mui/material";
import React from "react";
import styles from "./CounterButton.module.css";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

function CounterButton(props: any) {
  const {
    onIncrement,
    count,
    onDecrement,
    incrementDisable = false,
    decrementDisable = false,
    variant,
  } = props;

  const getButtonStyle = () => {
    switch (variant) {
      case "primary":
        return styles.primaryBtn;
      case "secondary":
        return styles.secondaryBtn;
      case "tertiary":
        return styles.tertiaryBtn;

      default:
        return "";
    }
  };
  return (
    <>
      <ButtonGroup
        sx={{ border: "0.905797px solid #E6E6E6" }}
        className={`${getButtonStyle()} ${styles.defaultCounterWrap}`}
      >
        <Button
          disabled={decrementDisable}
          aria-label="reduce"
          onClick={() => {
            onDecrement();
          }}
          className={styles.manageBillingUserCountBtn}
          sx={{
            padding: "7px 7px",
            minWidth: "28px !important",
            border: "none !important",
            background: " #F8F8F8",
            color: "#667085",
            maxWidth: "28px",
            height: "31px",
            " &:hover ": {
              background: " #F8F8F8",
              border: "none",
            },
            "& .MuiButtonGroup-root.MuiButtonGroup-grouped": {
              minWidth: "28px",
            },
          }}
        >
          <RemoveIcon fontSize="small" />
        </Button>
        <div className={styles.defaultCounterCount}>{count}</div>

        <Button
          aria-label="increase"
          onClick={() => {
            onIncrement();
          }}
          sx={{
            padding: "7px 7px",
            minWidth: "28px !important",
            border: "none",
            background: " #F8F8F8",
            color: "#667085",
            maxWidth: "28px",
            height: "31px",
            borderLeft: "1px solid #e6e6e6",
            " &:hover ": {
              background: " #F8F8F8",
              border: "none",
              borderLeft: "1px solid #e6e6e6",
            },
            "& .MuiButtonGroup-root.MuiButtonGroup-grouped": {
              minWidth: "28px",
            },
          }}
          disabled={incrementDisable}
        >
          <AddIcon fontSize="small" />
        </Button>
      </ButtonGroup>
    </>
  );
}

export default CounterButton;
